export default {
  hour: 'Hour',
  minute: 'Minute',
};
